// advertisementContainer
import React, { useState, useRef, useEffect } from "react";
import { header, people } from "../../config/imagesLink";
import Select from "react-select";
import axios, { productionWork } from "../../API/axios";
import { debounce } from "lodash";
import TranslateIcon from '@mui/icons-material/Translate';
import { Button, Dropdown } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import Toggle from "../../Toggle";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LeftNavigation from "./LeftNavigation";
import CreateCompany from "../CreateCompany/CreateCompany";
import TopNotification from "./TopNotification";
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import PersonOutlineSharpIcon from '@mui/icons-material/PersonOutlineSharp';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';
import AdminPanelSettingsSharpIcon from '@mui/icons-material/AdminPanelSettingsSharp';
import PowerSettingsNewSharpIcon from '@mui/icons-material/PowerSettingsNewSharp';
import MenuSharpIcon from '@mui/icons-material/MenuSharp';
import base58 from "base-58";
import { Buffer } from "buffer";
import TopMessage from "./TopMessage";
import moment from "moment";
import useChatStore from "../OuterChatBox/useChatStore";
import CheckIcon from "@mui/icons-material/Check";
import { Tooltip } from "@mui/material";
import { ShimmerTitle } from "react-shimmer-effects";
import { ShimmerDiv } from "@skeleton";
import { ADMIN_APP_ORIGIN, joinUrl } from "../../config/appConfig";
import { disconnectRealtimeHub } from "../../Services/apiService";
import i18n from "../../i18n";
import { t } from "i18next";
const suggestions = [
  "Apple",
  "Banana",
  "Cherry",
  "Date",
  "Elderberry",
  "Fig",
  "Grape",
  "Honeydew",
  "Kiwi",
  "Lemon",
];
const Header = ({ isDark, setIsDark, notifiCount, setNotifiCount, NotificationCount, MessagesCount }) => {
  const guestModeData = localStorage.getItem("guestMode");
  const sessionId = localStorage.getItem("sessionId");
  const language = localStorage.getItem("Lang");
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const userUid = localStorage.getItem("userUid");
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n?.language || language || "en");


  const { clearAllChats } = useChatStore();

  const toggleMenu = () => {
    setIsOpen((prevState) => !prevState);
    console.log("Menu is toggling...");
  };

  const [showSub, setShowSub] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownRes, setShowDropdownRes] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const toggleDropdownRes = () => {
    setShowDropdownRes(!showDropdownRes);
  };
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  //************************Search Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };
  const [options, setOptions] = useState([]);
  const [searchUser, setSearchUser] = useState([]);
  const [searchHashtag, setSearchHashtag] = useState([]);
  const [searchComp, setSearchComp] = useState([]);
  const [searchJob, setSearchJob] = useState([]);
  const [searchPost, setSearchPost] = useState([]);
  const [searchBlog, setSearchBlog] = useState([]);

  const clearSearchDropdown = () => {
    setOptions([]);
    setInputValue("");
    setSearchUser([]);
    setSearchHashtag([]);
    setSearchComp([]);
    setSearchJob([]);
    setSearchPost([]);
    setSearchBlog([]);
  };

  const addOptions = () => {
    setIsLoading(true);
    const data = {
      deviceType: "Web",
      pageNumber: page,
      pageSize: 30,
    };
    axios
      .post(`SMFeatures/GlobalSearch?search=${inputValue}`, data)
      .then((response) => {
        console.log("Response:", response);

        if (
          !response.data ||
          !response.data.responseData ||
          !response.data.responseData.searchdata
        ) {
          console.log("Invalid response structure:", response);
          setIsError(true);
          setIsLoading(false);
          return;
        }

        let data = response.data.responseData.searchdata;
        console.log("Original Data:", data);

        // ✅ SHOW ERROR ONLY IF EMPTY ARRAY
        if (Array.isArray(data) && data.length === 0) {
          setIsError(true);
          setSearchUser([]);
          setSearchHashtag([]);
          setSearchComp([]);
          setSearchJob([]);
          setSearchPost([]);
          setSearchBlog([]);
          setIsLoading(false);
          return;
        }
        // Process the data to extract the type and followers count
        setIsError(false);
        data = data.map((item) => {
          const [type, followers] = String(item?.type || "").split(",");
          return {
            ...item,
            type: type?.trim(),
            followers: parseInt(followers, 10),
          };
        });


        // console.log("Processed Data:", data);
        const addUniqueItems = (data, type) => {
          const uniqueItems = data.filter((item) => item.type === type);
          return uniqueItems;
        };

        // Clear the previous results and set the new data
        setSearchUser(addUniqueItems(data, "User"));
        setSearchHashtag(addUniqueItems(data, "Hashtag"));
        setSearchComp(addUniqueItems(data, "Company"));
        setSearchJob(addUniqueItems(data, "Job"));
        setSearchPost(
          data.filter((item) => item.type === "Post"  )
        );
        setSearchBlog(addUniqueItems(data, "Blog"));

        setIsLoading(false);
        setTotalPages(response.data.responseData.paging.totalPages);

        setOptions((prev) => {
          const postSet = new Set(prev.map((post) => post.id));
          const uniqueNewPosts = data.filter((post) => !postSet.has(post.id));
          return [...prev, ...uniqueNewPosts];
        });

      })
      .catch((error) => {
        console.log("Error:", error);
        // setIsLoading(false);
      });
  };

  useEffect(() => {
    const controller = new AbortController();
    const delayDebounce = setTimeout(() => {
      if (inputValue && inputValue.trim().length >= 3) {
        addOptions(inputValue, controller.signal);
      } else {
        setOptions([]);
        setSearchUser([]);
        setSearchHashtag([]);
        setSearchComp([]);
        setSearchJob([]);
        setSearchPost([]);
        setSearchBlog([]);
      }
    }, 1000);

    return () => {
      clearTimeout(delayDebounce);
      controller.abort(); // cancel the API call if component updates/unmounts
    };
  }, [inputValue, page]);

  // useEffect(() => {
  //   if (inputValue) {
  //     addOptions();
  //   } else {
  //     setOptions([]);
  //     setSearchUser([]);
  //     setSearchComp([]);
  //     setSearchJob([]);
  //     setSearchPost([]);
  //   }
  // }, [inputValue, page]);

  const dropdownRef1 = useRef(null);

  const handleInfiniteScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = dropdownRef1.current;
    console.log("ScrollTop:", scrollTop);
    console.log("ClientHeight:", clientHeight);
    console.log("ScrollHeight:", scrollHeight);

    if (scrollTop + clientHeight >= scrollHeight - 1) {
      console.log("Bottom reached, increasing page");
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (dropdownRef1.current) {
      dropdownRef1.current.addEventListener("scroll", handleInfiniteScroll);
      return () =>
        dropdownRef1.current.removeEventListener(
          "scroll",
          handleInfiniteScroll
        );
    }
  }, [dropdownRef1]);

  const [profilPic, setProfilPic] = useState(localStorage.getItem("profilPic"));

  useEffect(() => {
    const handleProfilePicUpdate = (event) => {
      setProfilPic(event.detail);
    };

    window.addEventListener("profilePicUpdated", handleProfilePicUpdate);

    return () => {
      window.removeEventListener("profilePicUpdated", handleProfilePicUpdate);
    };
  }, []);

  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === "/NewsFeed") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const searchContainerRef = useRef(null);
  const dropdownRef = useRef(null);
  const langdropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target) &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setOptions([]);
        setInputValue("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if ((dropdownRef.current && !dropdownRef.current.contains(event.target))
      &&
      (langdropdownRef.current && !langdropdownRef.current.contains(event.target))
    ) {
      setShowDropdown(null);
      setShowSub(null)
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //   const base64SessionId = btoa(sessionId);

  const [encodedValue, setEncodedValue] = useState("");
  const [encodedTokenValue, setEncodedTokenValue] = useState("");

  // const handleEncode = () => {
  //   const encoded = base58.encode(Buffer.from(sessionId));

  //   setEncodedValue(encoded);
  //   const encodedToken = base58.encode(Buffer.from(token));
  //   setEncodedTokenValue(encodedToken);
  //   // console.log(encoded);
  // };

  // useEffect(() => {
  //   if (!guestModeData) {
  //     handleEncode();
  //   }
  // }, []);

  const handleEncode = () => {
    // Ensure sessionId and token are converted to strings if they are not already
    const sessionIdStr = typeof sessionId === 'string' ? sessionId : JSON.stringify(sessionId);
    const tokenStr = typeof token === 'string' ? token : JSON.stringify(token);

    const encoded = base58.encode(Buffer.from(sessionIdStr));
    setEncodedValue(encoded);

    const encodedToken = base58.encode(Buffer.from(tokenStr));
    setEncodedTokenValue(encodedToken);
  };

  useEffect(() => {
    if (!guestModeData) {
      handleEncode();
    }
  }, []);


  const handleAction = () => {
    console.log("action is working");
  };

  const [showDeleteReviewModal, setShowDeleteReviewModal] = useState(false);
  const handleCloseDeleteReviewModal = () => setShowDeleteReviewModal(false);


  // ....................Message
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (open) {
        setOpen(false); // Hide tooltip when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [open]);

  // .............Notification
  const [openNotification, setOpenNotification] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (openNotification) {
        setOpenNotification(false); // Hide tooltip when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openNotification]);

  // .......................Profile
  const [openProfile, setOpenProfile] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (openProfile) {
        setOpenProfile(false); // Hide tooltip when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openProfile]);

  // .................................................


  // function LanguageSwitcher() {

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    console.log("select Lang", lang);
    localStorage.setItem("Lang", lang);
    setCurrentLang(lang);

    // document.body.dir = lang === "ar" ? "rtl" : "ltr"; // RTL for Arabic
  };


  const normalizeSearchTitle = (value) => {
    if (value === null || value === undefined) return "";

    const rawValue = String(value);
    let parsedValue = null;

    try {
      parsedValue = JSON.parse(rawValue);
    } catch (error) {
      parsedValue = null;
    }

    if (Array.isArray(parsedValue)) {
      const tags = parsedValue
        .map((item) => item?.displayName)
        .filter(Boolean)
        .map((name) => `#${name}`);

      if (tags.length > 0) {
        return [...new Set(tags)].join(" ");
      }
    }

    let cleanedText = rawValue.replace(/\{\d*\}/g, " ");

    if (typeof DOMParser !== "undefined") {
      const parser = new DOMParser();
      cleanedText = parser.parseFromString(cleanedText, "text/html").body.textContent || cleanedText;
    } else {
      cleanedText = cleanedText.replace(/<[^>]*>/g, " ");
    }

    cleanedText = cleanedText.replace(/\s+/g, " ").trim();

    if (!cleanedText) {
      const hashtags = [...rawValue.matchAll(/\/hashtag\/([^"'/?#\s>]+)/gi)].map((match) => {
        try {
          return `#${decodeURIComponent(match[1])}`;
        } catch (error) {
          return `#${match[1]}`;
        }
      });

      if (hashtags.length > 0) {
        return [...new Set(hashtags)].join(" ");
      }
    }

    return cleanedText;
  };

  const normalizeSearchMeta = (value) => {
    if (value === null || value === undefined) return "";

    const rawValue = String(value).trim();
    if (!rawValue) return "";

    let parsedValue = null;
    try {
      parsedValue = JSON.parse(rawValue);
    } catch (error) {
      parsedValue = null;
    }

    if (Array.isArray(parsedValue)) {
      const tags = parsedValue
        .map((item) => item?.displayName)
        .filter(Boolean)
        .map((name) => `#${name}`);

      return [...new Set(tags)].join(" ");
    }

    if (parsedValue && typeof parsedValue === "object") {
      return "";
    }

    let cleanedText = rawValue.replace(/\{\d*\}/g, " ");

    if (typeof DOMParser !== "undefined") {
      const parser = new DOMParser();
      cleanedText = parser.parseFromString(cleanedText, "text/html").body.textContent || cleanedText;
    } else {
      cleanedText = cleanedText.replace(/<[^>]*>/g, " ");
    }

    return cleanedText.replace(/\s+/g, " ").trim();
  };

  const formatPostSearchItem = (item) => {
    const title = normalizeSearchTitle(item?.title);
    const additionalInfo = normalizeSearchMeta(item?.additionalInfo);
    const description = normalizeSearchMeta(item?.description);

    return {
      title,
      additionalInfo: additionalInfo && additionalInfo !== title ? additionalInfo : "",
      description:
        description && description !== title && description !== additionalInfo
          ? description
          : "",
    };
  };

  const getPostSearchLink = (item) => {
    const normalizedTitle = normalizeSearchTitle(item?.title || "");
    const isHashtagType = item?.type === "Hashtag";
    const looksLikeHashtag = normalizedTitle.startsWith("#") && !!item?.slug;

    if ((isHashtagType || looksLikeHashtag) && item?.slug) {
      return `/hashtag/${encodeURIComponent(item.slug)}`;
    }

    return `/Post/${item?.id}/${item?.slug}`;
  };
  return (
    <>
      <div className="mainheader headerLayout desktopView">
        <div className="row">
          <div className="col-md-3 left">
            <NavLink to="/NewsFeed" onClick={handleLogoClick}>
              {isDark ? (
                <div className="Logo">
                  <img src={header.whiteoglogo} alt="" />
                </div>
              ) : (
                <div className="Logo">
                  <img src={header.oglogo} alt="" />
                </div>
              )}
            </NavLink>
          </div>

          <div className="col-md-6 center ps-0" ref={searchContainerRef}>
            <div className="search-container" style={{
              direction: language === "ar" ? "rtl" : "ltr",
              textAlign: language === "ar" ? "right" : "left"
            }}>
              <SearchSharpIcon className="material-symbols-sharp" />
              <div className="search-input-container">
                <input

                  type="text"
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                  }}
                  placeholder={t("SearchJob.Search")}
                  className="search-input"
                />

                {(options.length > 0 || inputValue !== "") && (
                  <ul className="suggestions-dropdown" ref={dropdownRef1}>
                     <div className="dropdown-scroll">
                    
                    <div className="notificationscroller">
                      {/* {searchUser.length > 0 && (
                        <div style={{ margin: "4px 16px" }}>
                          <p style={{ margin: "0", fontWeight: "800" }}>People</p>
                        </div>
                      )}
                      {searchUser.map((item, index) => (
                        <Link to={`/User/${item?.id}`} key={index}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              console.log("On Click Option")
                              setOptions([]);
                              setInputValue("");
                              setSearchUser([]);
                              setSearchComp([]);
                              setSearchJob([]);
                              setSearchPost([]);
                              setSearchBlog([]);
                            }}
                          >
                            <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              style={{ borderRadius: "50px" }}
                            />
                            <div>
                              <p className="ms-2">{normalizeSearchTitle(item?.title)}</p>
                              <p className="ms-2 f-12">{item?.additionalInfo}</p>
                              <p className="ms-2 f-12">{item?.description}</p>
                              <p className="ms-2 f-12">
                                {item?.followers} followers
                              </p>
                            </div>
                          </li>
                        </Link>
                      ))} */}
                      {isLoading ? (
                        <>
                          <div className="shimmer-cont d-flex">
                            <ShimmerDiv className="mt-2"
                              height={50} width={50} rounded={50} />
                            <div className="shimmer-header d-flex">
                              <ShimmerDiv height={50} width={"100%"} />
                            </div>
                          </div>
                          <div className="shimmer-cont d-flex">
                            <ShimmerDiv className="mt-2"
                              height={50} width={50} rounded={50} />
                            <div className="shimmer-header d-flex">
                              <ShimmerDiv height={50} width={"100%"} />
                            </div>
                          </div>
                        </>
                      ) : isError ? (
                        <div className="error-message p-3">
                          <p>{t("SearchJob.There is no search result")}</p>
                        </div>
                      ) : (
                        <>
                          {searchUser.length > 0 && (
                            <div style={{ margin: "4px 16px" }}>
                              <p style={{ margin: "0", fontWeight: "800" }}>{t("Sidemenubar.People")}</p>
                            </div>
                          )}
                          {searchUser.map((item, index) => (
                            <Link to={`/User/${item?.id}/${item?.slug}`} key={index}>
                              <li
                                className="suggestion-item d-flex"
                                onClick={() => {
                                  console.log("On Click Option");
                                  setOptions([]);
                                  setInputValue("");
                                  setSearchUser([]);
                                  setSearchComp([]);
                                  setSearchJob([]);
                                  setSearchPost([]);
                                  setSearchBlog([]);
                                  setSearchHashtag([]);
                                }}
                              >
                                <img
                                  src={item?.image}
                                  alt=""
                                  width={30}
                                  height={30}
                                  style={{ borderRadius: "50px" }}
                                />
                                <div>
                                  <p className="ms-2">{item?.title}</p>
                                  <p className="ms-2 f-12">{item?.additionalInfo}</p>
                                  <p className="ms-2 f-12">{item?.description}</p>
                                {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p>}
                                </div>
                              </li>
                            </Link>
                          ))}
                        </>
                      )}

                      {searchBlog.length > 0 && (
                        <div style={{ margin: "4px 16px" }}>
                          <p style={{ margin: "0", fontWeight: "800" }}>{t("Sidemenubar.Blogs")}</p>
                        </div>
                      )}
                      {searchBlog.map((item, index) => (

                        // <Link to={`/blogs/${item.title}`} key={index}>
                        <Link to={"/blogs/" + item.additionalInfo}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              setOptions([]);
                              setInputValue("");
                            }}
                          >
                            <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              style={{ borderRadius: "50px" }}
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              <p className="ms-2 f-12">{item?.additionalInfo}</p>
                              {/* <p className="ms-2 f-12">{item?.description}</p> */}
                              <p className="ms-2 f-12">
                                {item?.description
                                  ? moment(item.description).format("dddd, MMMM D, YYYY")
                                  : ""}
                              </p>
                              {/* <p className="ms-2 f-12">
                                {item?.followers} followers
                              </p> */}
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchComp.length > 0 && (
                        <div style={{ margin: "4px 16px" }}>
                          <p style={{ margin: "0", fontWeight: "800" }}>
                            {t("Sidemenubar.Companies")}
                          </p>
                        </div>
                      )}
                      {searchComp.map((item, index) => (
                        <Link to={`/Company/${item?.id}/${item?.slug}`} key={index}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              setOptions([]);
                              setInputValue("");
                            }}
                          >
                            <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              style={{ borderRadius: "50px" }}
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              <p className="ms-2 f-12">{item?.additionalInfo}</p>
                              <p className="ms-2 f-12">{item?.description}</p>
                              {item?.followers > 0 && (
                                <p className="ms-2 f-12">
                                  {item?.followers} {t("My Connection.Followers")}
                                </p>
                              )}
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchJob.length > 0 && (
                        <div style={{ margin: "4px 16px" }}>
                          <p style={{ margin: "0", fontWeight: "800" }}>{t("User Profile.Jobs")}</p>
                        </div>
                      )}
                      {searchJob.map((item, index) => (
                        <Link to={`/JobDetail/${item?.id}/${item?.slug}`} key={index}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              setOptions([]);
                              setInputValue("");
                            }}
                          >
                            <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              style={{ borderRadius: "50px" }}
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              <p className="ms-2 f-12">{item?.additionalInfo}</p>
                              <p className="ms-2 f-12">{item?.description}</p>
                              {/* <p className="ms-2 f-12">
                                {item?.followers} {t("My Connection.Followers")}
                              </p> */}
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchPost.length > 0 && (
                        <div style={{ margin: "4px 16px" }}>
                          <p style={{ margin: "0", fontWeight: "800" }}>{t("Newsfeed.Post")}</p>
                        </div>
                      )}
                      {searchPost.map((item, index) => {
                        const formattedPost = formatPostSearchItem(item);
                        const postLink = getPostSearchLink(item);
                        const isHashtag =
                          item?.type === "Hashtag" ||
                          (normalizeSearchTitle(item?.title || "").startsWith("#") && !!item?.slug);

                        const content = (
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              setOptions([]);
                              setInputValue("");
                            }}
                          >
                            {/* <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              style={{ borderRadius: "50px" }}
                            /> */}
                            <div>
                              <p className="ms-2">{formattedPost.title}</p>
                              {formattedPost.description && (
                                <p className="ms-2 f-12">{formattedPost.description}</p>
                              )}
                            </div>
                          </li>
                        );

                        return isHashtag ? (
                          <a href={postLink} target="_blank" rel="noopener noreferrer" key={index}>
                            {content}
                          </a>
                        ) : (
                          <Link to={postLink} key={index}>
                            {content}
                          </Link>
                        );
                      })}
                      {searchHashtag.length > 0 && (
                        <div style={{ margin: "4px 16px" }}>
                          <p style={{ margin: "0", fontWeight: "800" }}>{t("Newsfeed.Hashtag")}</p>
                        </div>
                      )}
                      {searchHashtag.map((item, index) => {
                        const formattedPost = formatPostSearchItem(item);
                        const postLink = getPostSearchLink(item);
                        const isHashtag =
                          item?.type === "Hashtag" ||
                          (normalizeSearchTitle(item?.title || "").startsWith("#") && !!item?.slug);

                        const content = (
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              setOptions([]);
                              setInputValue("");
                            }}
                          >
                            {/* <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              style={{ borderRadius: "50px" }}
                            /> */}
                            <div>
                              <p className="ms-2">{formattedPost.title}</p>
                              {formattedPost.description && (
                                <p className="ms-2 f-12">{formattedPost.description}</p>
                              )}
                            </div>
                          </li>
                        );

                        return isHashtag ? (
                          <a href={postLink} target="_blank" rel="noopener noreferrer" key={index}>
                            {content}
                          </a>
                        ) : (
                          <Link to={postLink} key={index}>
                            {content}
                          </Link>
                        );
                      })}

                    

                    </div>
                      
                     </div>
                    {(searchUser.length > 0 || searchHashtag.length > 0 || searchComp.length > 0 || searchJob.length > 0 || searchPost.length > 0 || searchBlog.length > 0) && (
                         <div className="dropdown-footer">
                             <span className="see-all p-2 ms-2 f-14">
                                <Link
                                  to="/SearchResult"
                                  state={{ searchQuery: inputValue }}
                                  className=" "
                                  onClick={() => {
                                    clearSearchDropdown();
                                  }}
                                >
                                {t("SearchJob.See all results")}
                                </Link>
                              </span> 
                         </div>
                                   
                     ) }
                  </ul>
                )}
              </div>
            </div>
          </div>

          {/* --------------------- Guest Mode ---------------------------- */}

          <div className="col-md-3 right">
            {guestModeData === "true" ? (
              // <div>
              <div className="header-action guestMode d-flex justify-content-end align-items-center">
                <Toggle
                  isChecked={isDark}
                  // handleChange={() => setIsDark(!isDark)}
                  handleChange={() => setIsDark(prev => !prev)}
                />

                <Dropdown className="language-dropdown me-2 SlidetoDown">
                  <Dropdown.Toggle
                    id="language-toggle"
                    variant="link"
                    className="text-decoration-none p-0 d-flex align-items-center language-btn"
                  >
                    <TranslateIcon fontSize="small" className="me-2"
                      style={{ color: isDark ? '#fff' : '#333' }} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    {["en", "hi", "ar"].map((lang) => (
                      <Dropdown.Item
                        key={lang}
                        as="button"
                        style={{ width: "150px" }}
                        onClick={() => changeLanguage(lang)}
                      >
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <span>{lang === "en" ? "English" : lang === "hi" ? "Hindi" : "Arabic"}</span>
                          {currentLang === lang && (
                            <span style={{ color: "#0d6efd", fontWeight: 600 }}>✓</span>
                          )}
                        </div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <button
                  className="mainBtn guesBtn px-1 f-14"
                  style={{ height: "40px" }}
                >
                  {t("Notifications.Guest Mode")}
                </button>


              </div>
            ) : (
              // </div>
              <div className="header-action d-flex align-items-center justify-content-end Tooltip">
                {/* <Link to="/Notification" className="mt-1"> */}
                <Tooltip className="Notification-Tooltip" title={t("Notifications.Notification")} arrow
                  open={openNotification}
                  onOpen={() => setOpenNotification(true)}
                  onClose={() => setOpenNotification(false)}
                  // Huzaifa changes
                  disableHoverListener
                // Huzaifa changes
                >

                  <div className="notification d-flex justify-content-center  align-items-center mt-1"
                    // Huzaifa changes
                    onMouseEnter={() => setOpenNotification(true)}
                    onMouseLeave={() => setOpenNotification(false)}
                  // onMouseEnter={() => setOpenNotification(false)}
                  // onMouseLeave={() => setOpenNotification(false)}
                  // Huzaifa changes
                  >
                    {guestModeData !== "true" && <TopNotification
                      notifiCount={notifiCount}
                      setNotifiCount={setNotifiCount}
                      closeTooltip={() => setOpenNotification(false)}
                    />}
                  </div>
                </Tooltip>

                {/* </Link> */}
                {/* <Link to="/Message" className="mt-1"> */}

                <Tooltip className="Messages-Tooltip" title={t("Notifications.Messages")} arrow
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  // Huzaifa changes
                  disableHoverListener
                // Huzaifa changes
                >
                  <div className="notification d-flex justify-content-center  align-items-center mt-1"
                    // Huzaifa changes
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                  // onMouseEnter={() => setOpen(false)}
                  // onMouseLeave={() => setOpen(false)}
                  // Huzaifa changes
                  >
                    {guestModeData !== "true" && <TopMessage
                      MessagesCount={MessagesCount}
                      closeTooltip={() => setOpen(false)}
                    />}
                  </div>
                </Tooltip>

                {/* </Link> */}
                <Tooltip title={t("Notifications.Profile")} arrow
                      open={openProfile}
                      onOpen={() => setOpenProfile(true)}
                      onClose={() => setOpenProfile(false)}
                      // Huzaifa changes
                      disableHoverListener
                    // Huzaifa changes
                    >
                  <div className="user mt-1 desktop-dropdown"
                    onMouseEnter={() => setOpenProfile(true)}
                    onMouseLeave={() => setOpenProfile(false)}
                  >
                    <img
                      src={profilPic}
                      width={40}
                      height={40}
                      style={{ cursor: "pointer", borderRadius: "50%" }}
                      alt=""
                      // Huzaifa changes
                      // onClick={() => setShowDropdown(!showDropdown)}
                      onClick={() => {
                        setShowDropdown(!showDropdown);
                        setOpenProfile(false);
                      }}
                    // Huzaifa changes
                    />


                    {showDropdown && (
                      <Dropdown.Menu show={showDropdown} ref={dropdownRef}
                        // Huzaifa changes
                        onMouseEnter={() => setOpenProfile(false)}
                        onMouseLeave={() => setOpenProfile(false)}
                      // Huzaifa changes
                      >
                        <Dropdown.Item as="button" className="dropdownList">
                          <Link to={`/User/${userUid}`} onClick={toggleDropdown}>
                            <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt">{t("Notifications.Profile")}</span>
                          </Link>
                        </Dropdown.Item>

                        <Dropdown.Item as="button" className="dropdownList">
                          <Link to="/Settings/profile" onClick={toggleDropdown}>
                            <SettingsSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt">{t("Notifications.Settings")}</span>
                          </Link>
                        </Dropdown.Item>

                        <Dropdown.Item as="div" style={{ cursor: "pointer" }} ref={langdropdownRef}
                          onClick={() => setShowSub(!showSub)}
                        >
                          <TranslateIcon className="material-symbols-sharp me-2" />
                          {t("Notifications.Language")} ({language})
                          <ArrowDropDownIcon className="material-symbols-sharp ms-3" />
                          {showSub && (<Dropdown.Menu
                            show={showSub}
                            style={{
                              top: "78px",
                              right: "168px",
                            }}
                            className="sub-menu"
                          >
                            {["en", "hi", "ar"].map((lang) => (
                              <Dropdown.Item
                                key={lang}
                                as="button"
                                className="dropdownList d-flex justify-content-between align-items-center"
                                // onClick={() => changeLanguage(lang)}
                                onClick={() => {
                                  changeLanguage(lang);
                                  setTimeout(() => {
                                    window.location.reload();
                                  }, 150); // small delay so language state updates first
                                }}

                                disabled={language === lang} // disable current lang
                                style={{
                                  opacity: language === lang ? 0.6 : 1,
                                  cursor: language === lang ? "default" : "pointer",
                                }}
                              >
                                <span>
                                  {lang === "en" ? "English" : lang === "hi" ? "Hindi" : "Arabic"}
                                </span>

                                {language === lang && <CheckIcon fontSize="small" />}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                          )}
                        </Dropdown.Item>


                        {userRole === "Admin" ? (
                          <Dropdown.Item as="button" className="dropdownList">
                            <Link
                              to={joinUrl(ADMIN_APP_ORIGIN, `${encodedValue}/${encodedTokenValue}`)}
                              target="blank"
                              onClick={toggleDropdown}
                            >
                              <AdminPanelSettingsSharpIcon className="material-symbols-sharp me-2" />
                              <span className="dropdownTxt">{t("Notifications.Go To Admin")}</span>
                            </Link>
                          </Dropdown.Item>
                        ) : (
                          ""
                        )}

                        <Dropdown.Divider />

                        <Dropdown.Item as="button" className="dropdownList">
                          <Link
                            className="d-flex align-items-center"
                            to="/signIn"
                            onClick={() => {
                              disconnectRealtimeHub();
                              localStorage.clear();
                              clearAllChats();
                              sessionStorage.removeItem('hasModalShown');
                              localStorage.setItem("Lang", language);

                            }}
                          >
                            <PowerSettingsNewSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt">{t("Notifications.Logout")}</span>
                          </Link>
                        </Dropdown.Item>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          className="py-1"
                        >
                          <Toggle
                            isChecked={isDark}
                            // handleChange={() => setIsDark(!isDark)}
                            handleChange={() => setIsDark(prev => !prev)}

                          />
                        </div>
                      </Dropdown.Menu>
                    )}
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        {!productionWork &&
          <p className="productionWorkPara text-dark" style={{ textAlign: 'center', padding: '1px', fontSize: '12px', backgroundColor: "#f2d57c" }}>
            It's preproduction work.</p>
        }
      </div>

      {/*------------------- Profile dropdown for Mobile view ------------------------------- */}

      <div className="mainheader align-items-center mobileView">
        <MenuSharpIcon className="material-symbols-sharp pointer" onClick={toggleMenu} />
        <div className="search-container">
          <div className="search-icon">
            <SearchSharpIcon className="material-symbols-sharp" />

          </div>
          <div className="search-input-container">
            <input
              type="text"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              placeholder="Search.."
              className="search-input"
            />

            {(options.length > 0 || inputValue !== "") && (
              <ul className="suggestions-dropdown" ref={dropdownRef1}>
                {searchUser.length > 0 && (
                  <div style={{ margin: "4px 16px" }}>
                    <p style={{ margin: "0", fontWeight: "800" }}>{t("Sidemenubar.People")}</p>
                  </div>
                )}
                {searchUser.map((item, index) => (
                  <Link to={`/User/${item?.id}/${item?.slug}`} key={index}>
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        setOptions([]);
                        setInputValue("");
                      }}
                    >
                      <img
                        src={item?.image}
                        alt=""
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        <p className="ms-2 f-12">{item?.additionalInfo}</p>
                        <p className="ms-2 f-12">{item?.description}</p>
                       {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p>}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchComp.length > 0 && (
                  <div style={{ margin: "4px 16px" }}>
                    <p style={{ margin: "0", fontWeight: "800" }}>{t("Sidemenubar.Companies")}</p>
                  </div>
                )}
                {searchComp.map((item, index) => (
                  <Link to={`/Company/${item?.id}/${item?.slug}`} key={index}>
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        setOptions([]);
                        setInputValue("");
                      }}
                    >
                      <img
                        src={item?.image}
                        alt=""
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        <p className="ms-2 f-12">{item?.additionalInfo}</p>
                        <p className="ms-2 f-12">{item?.description}</p>
                       {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p>}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchJob.length > 0 && (
                  <div style={{ margin: "4px 16px" }}>
                    <p style={{ margin: "0", fontWeight: "800" }}>{t("User Profile.Jobs")}</p>
                  </div>
                )}
                {searchJob.map((item, index) => (
                  <Link to={`/JobDetail/${item?.id}//${item?.slug}`} key={index}>
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        setOptions([]);
                        setInputValue("");
                      }}
                    >
                      {/* <img
                        src={item?.image}
                        alt=""
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                      /> */}
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        <p className="ms-2 f-12">{item?.additionalInfo}</p>
                        <p className="ms-2 f-12">{item?.description}</p>
                        {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p>}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchPost.length > 0 && (
                  <div style={{ margin: "4px 16px" }}>
                    <p style={{ margin: "0", fontWeight: "800" }}>{t("Newsfeed.Post")}</p>
                  </div>
                )}
                {searchPost.map((item, index) => {
                  const formattedPost = formatPostSearchItem(item);
                  const postLink = getPostSearchLink(item);
                  const isHashtag =
                    item?.type === "Hashtag" ||
                    (normalizeSearchTitle(item?.title || "").startsWith("#") && !!item?.slug);

                  const content = (
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        setOptions([]);
                        setInputValue("");
                      }}
                    >
                      {/* <img
                        src={item?.image}
                        alt=""
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                      /> */}
                      <div>
                        <p className="ms-2">{formattedPost.title}</p>
                        {formattedPost.additionalInfo && (
                          <p className="ms-2 f-12">{formattedPost.additionalInfo}</p>
                        )}
                        {formattedPost.description && (
                          <p className="ms-2 f-12">{formattedPost.description}</p>
                        )}
                        {/* <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p> */}
                      </div>
                    </li>
                  );

                  return isHashtag ? (
                    <a href={postLink} target="_blank" rel="noopener noreferrer" key={index}>
                      {content}
                    </a>
                  ) : (
                    <Link to={postLink} key={index}>
                      {content}
                    </Link>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
        {guestModeData === "true" ? (
          <div className="header-action d-flex justify-content-between align-items-end ">
            {/* <Tooltip title="Notification" arrow
            open={openNotification}
            onOpen={() => setOpenNotification(true)}
            onClose={() => setOpenNotification(false)}> */}

            <div className="notification d-flex justify-content-center  align-items-center mt-1 HideOnMobileDevice"
              onMouseEnter={() => setOpenNotification(true)}
              onMouseLeave={() => setOpenNotification(false)}>
              {guestModeData !== "true" && <TopNotification
                notifiCount={notifiCount}
                setNotifiCount={setNotifiCount} />}
            </div>
            {/* </Tooltip> */}

            {/* <Tooltip title="Messages" arrow
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}> */}
            <div className="notification d-flex justify-content-center  align-items-center mt-1 HideOnMobileDevice"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}>
              {guestModeData !== "true" && <TopMessage />}
            </div>
            {/* </Tooltip> */}

            <div className="user ">
              <button
                className="mainBtn guesBtn px-1 f-14 ForSmallDevicebtn"
                onClick={() => setShowDropdownRes(!showDropdownRes)}
              >
                Guest
              </button>
              {showDropdownRes && (
                <Dropdown.Menu show={showDropdownRes}>
                  {/* <Dropdown.Item as="div" style={{ cursor: "pointer" }}
                  onClick={() => setShowSub(!showSub)}
                >
                  <TranslateIcon className="material-symbols-sharp me-2" />
                  {t("Notifications.Language")}
                  <ArrowDropDownIcon className="material-symbols-sharp ms-3" />
 
                  {showSub && (
                    <Dropdown.Menu show={showSub}
                      style={{
                        top: "78px",
                        right: "168px",
                      }}
                      className="sub-menu"

                    >
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("Eng")} >English</Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("Hin")} >Hindi</Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("Arb")} >Arabic</Dropdown.Item>
                    </Dropdown.Menu>
                  )}
                </Dropdown.Item> */}
                  <Dropdown.Item as="div" style={{ cursor: "pointer" }} ref={langdropdownRef}
                    onClick={() => setShowSub(!showSub)}
                  >
                    <TranslateIcon className="material-symbols-sharp me-2" />
                    {t("Notifications.Language")} ({language})
                    <ArrowDropDownIcon className="material-symbols-sharp ms-3" />
                    {showSub && (<Dropdown.Menu
                      show={showSub}
                      style={{
                        top: "78px",
                        right: "168px",
                      }}
                      className="sub-menu"
                    >
                      {["en", "hi", "ar"].map((lang) => (
                        <Dropdown.Item
                          key={lang}
                          as="button"
                          className="dropdownList d-flex justify-content-between align-items-center"
                          // onClick={() => changeLanguage(lang)}
                          onClick={() => {
                            changeLanguage(lang);
                            setTimeout(() => {
                              window.location.reload();
                            }, 150); // small delay so language state updates first
                          }}

                          disabled={language === lang} // disable current lang
                          style={{
                            opacity: language === lang ? 0.6 : 1,
                            cursor: language === lang ? "default" : "pointer",
                          }}
                        >
                          <span>
                            {lang === "en" ? "English" : lang === "hi" ? "Hindi" : "Arabic"}
                          </span>

                          {language === lang && <CheckIcon fontSize="small" />}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                    )}
                  </Dropdown.Item>

                  {userRole === "Admin" ? (
                    <Dropdown.Item as="button" className="dropdownList">
                      <Link
                        to={joinUrl(ADMIN_APP_ORIGIN, `${encodedValue}/${encodedTokenValue}`)}
                        target="blank"
                        onClick={toggleDropdownRes}
                      >
                        <AdminPanelSettingsSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt">{t("Notifications.Go To Admin")}</span>
                      </Link>
                    </Dropdown.Item>
                  ) : (
                    ""
                  )}

                  <Dropdown.Divider />

                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className="py-1"
                  >
                    <Toggle
                      isChecked={isDark}
                      handleChange={() => setIsDark(!isDark)}
                    />
                  </div>
                </Dropdown.Menu>
              )}
            </div>
          </div>
        ) : (
          <div className="header-action d-flex justify-content-between align-items-end ">
            {/* <Tooltip title="Notification" arrow
            open={openNotification}
            onOpen={() => setOpenNotification(true)}
            onClose={() => setOpenNotification(false)}> */}

            <div className="notification d-flex justify-content-center  align-items-center mt-1 HideOnMobileDevice"
              onMouseEnter={() => setOpenNotification(true)}
              onMouseLeave={() => setOpenNotification(false)}>
              {guestModeData !== "true" && <TopNotification
                notifiCount={notifiCount}
                setNotifiCount={setNotifiCount} />}
            </div>
            {/* </Tooltip> */}

            {/* <Tooltip title="Messages" arrow
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}> */}
            <div className="notification d-flex justify-content-center  align-items-center mt-1 HideOnMobileDevice"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}>
              {guestModeData !== "true" && <TopMessage />}
            </div>
            {/* </Tooltip> */}

            <div className="user ">
              <img
                src={profilPic}
                width={40}
                height={40}
                style={{ cursor: "pointer", borderRadius: "50%" }}
                alt=""
                onClick={() => setShowDropdownRes(!showDropdownRes)}
              />
              {showDropdownRes && (
                <Dropdown.Menu show={showDropdownRes}>
                  <Dropdown.Item className="dropdownList">
                    <Link to={`/User/${userUid}`} onClick={toggleDropdownRes}>
                      <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt">{t("Notifications.Profile")}</span>
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item as="button" className="dropdownList">
                    <Link to="/Settings/profile" onClick={toggleDropdownRes}>
                      <SettingsSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt">{t("Notifications.Settings")}</span>
                    </Link>
                  </Dropdown.Item>
                  {/* <Dropdown.Item as="div" style={{ cursor: "pointer" }}
                  onClick={() => setShowSub(!showSub)}
                >
                  <TranslateIcon className="material-symbols-sharp me-2" />
                  {t("Notifications.Language")}
                  <ArrowDropDownIcon className="material-symbols-sharp ms-3" />
 
                  {showSub && (
                    <Dropdown.Menu show={showSub}
                      style={{
                        top: "78px",
                        right: "168px",
                      }}
                      className="sub-menu"

                    >
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("Eng")} >English</Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("Hin")} >Hindi</Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("Arb")} >Arabic</Dropdown.Item>
                    </Dropdown.Menu>
                  )}
                </Dropdown.Item> */}
                  <Dropdown.Item as="div" style={{ cursor: "pointer" }} ref={langdropdownRef}
                    onClick={() => setShowSub(!showSub)}
                  >
                    <TranslateIcon className="material-symbols-sharp me-2" />
                    {t("Notifications.Language")} ({language})
                    <ArrowDropDownIcon className="material-symbols-sharp ms-3" />
                    {showSub && (<Dropdown.Menu
                      show={showSub}
                      style={{
                        top: "78px",
                        right: "168px",
                      }}
                      className="sub-menu"
                    >
                      {["en", "hi", "ar"].map((lang) => (
                        <Dropdown.Item
                          key={lang}
                          as="button"
                          className="dropdownList d-flex justify-content-between align-items-center"
                          // onClick={() => changeLanguage(lang)}
                          onClick={() => {
                            changeLanguage(lang);
                            setTimeout(() => {
                              window.location.reload();
                            }, 150); // small delay so language state updates first
                          }}

                          disabled={language === lang} // disable current lang
                          style={{
                            opacity: language === lang ? 0.6 : 1,
                            cursor: language === lang ? "default" : "pointer",
                          }}
                        >
                          <span>
                            {lang === "en" ? "English" : lang === "hi" ? "Hindi" : "Arabic"}
                          </span>

                          {language === lang && <CheckIcon fontSize="small" />}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                    )}
                  </Dropdown.Item>

                  {userRole === "Admin" ? (
                    <Dropdown.Item as="button" className="dropdownList">
                      <Link
                        to={joinUrl(ADMIN_APP_ORIGIN, `${encodedValue}/${encodedTokenValue}`)}
                        target="blank"
                        onClick={toggleDropdownRes}
                      >
                        <AdminPanelSettingsSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt">{t("Notifications.Go To Admin")}</span>
                      </Link>
                     </Dropdown.Item>
                    ) : (
                      ""
                    )}

                  <Dropdown.Divider />

                  <Dropdown.Item as="button" className="dropdownList">
                    <Link
                      className="d-flex align-items-center"
                      to="/signIn"
                      onClick={() => {
                        disconnectRealtimeHub();
                        localStorage.clear();
                        clearAllChats();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      <span className="dropdownTxt">{t("Notifications.Logout")}</span>
                    </Link>
                  </Dropdown.Item>

                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className="py-1"
                  >
                    <Toggle
                      isChecked={isDark}
                      handleChange={() => setIsDark(!isDark)}
                    />
                  </div>
                </Dropdown.Menu>
              )}
            </div>
          </div>
        )}
      </div>

      {isOpen && (
        <LeftNavigation
          isOpen={isOpen}
          toggleMenu={toggleMenu}
          setIsOpen={setIsOpen}
          openModal={openModal}
        />
      )}
      {showModal && (
        <CreateCompany
          openModal={openModal}
          showModal={showModal}
          closeModal={closeModal}
          getCompanyList={''}
        />
      )}
    </>
  );
};

export default Header;
